import { postRequest } from "../../../api/api";

export function postUpdateUserLanguage(values, callbackResponse) {
    return postRequest(
        'api/v1/change-locale',
        null,
        values,
        callbackResponse
    );
}